import React from 'react';
import i18n from 'util/i18n';
import { HISTORY, HISTORY_FEDERAL } from 'config/formSections/history';
import { formConfig } from 'config/forms';
import connectSubsection from 'components/Section/shared/SubsectionConnector';
import Subsection from 'components/Section/shared/Subsection';

import { Summary, DateSummary } from 'components/Summary';
import PropTypes from 'prop-types';
import { EmptyListInstance } from 'forms/shared/models';
import Branch from 'components/Form/Branch';
import Show from 'components/Form/Show';
import Accordion from 'components/Form/Accordion';
import Comments from 'components/Form/Comments';
import FederalItem from './FederalItem';
import { isPVQForm } from 'helpers/form';

const sectionConfig = {
  key: HISTORY_FEDERAL.key,
  section: HISTORY.name,
  store: HISTORY.store,
  subsection: HISTORY_FEDERAL.name,
  storeKey: HISTORY_FEDERAL.storeKey,
};

export class Federal extends Subsection {
  constructor(props) {
    super(props);

    const {
      section, subsection, store, storeKey
    } = sectionConfig;

    this.section = section;
    this.subsection = subsection;
    this.store = store;
    this.storeKey = storeKey;
    this.handleError = this.handleError.bind(this);
  }

  update = (queue) => {
    this.props.onUpdate('Federal', {
      HasFederalService: this.props.HasFederalService,
      List: this.props.List,
      Comments: this.props.Comments,
      SummaryComments: this.props.SummaryComments,
      ...queue,
    });
  };

  updateBranch = (values) => {
    this.update({
      HasFederalService: values,
      List: values.value === 'Yes' ? this.props.List : [],
    });
  };

  updateList = (values) => {
    this.update({
      List: values,
    });
  };

  updateComments = (values) => {
    this.update({
      Comments: values,
    });
  };

  updateSummaryComments = (values) => {
    this.update({
      SummaryComments: values,
    });
  };

  /**
   * Assists in rendering the summary section.
   */
  summary = (item, index) => {
    const summaryItem = (item && item.Item) || {};
    const agency = summaryItem && summaryItem.Name && summaryItem.Name.value ? summaryItem.Name.value : '';
    const dates = DateSummary(summaryItem.Dates);

    return Summary({
      type: i18n.t('history.federal.collection.summary.item'),
      index,
      left: agency,
      right: dates,
      placeholder: i18n.t('history.federal.collection.summary.unknown'),
    });
  };

  render() {
    const { formType, errors } = this.props;
    const accordionErrors = errors && errors.filter((e) => e.indexOf('List.accordion') === 0);
    const years = formType && formConfig[formType] && formConfig[formType].HISTORY_FEDERAL_YEARS;
    const isPVQ = isPVQForm(this.props.formType);

    return isPVQ ? (
      <div
        className="section-content federal"
        data-section={HISTORY.key}
        data-subsection={HISTORY_FEDERAL.key}
      >
        <Branch
          attribute="HasFederalService"
          name="has_federalservice"
          label={i18n.t('history.pvq.federal.heading.branch')}
          labelSize="h4"
          help="history.pvq.federal.help.branch"
          helpTitle={i18n.t('history.pvq.federal.help.branch.title', { years })}
          {...this.props.HasFederalService}
          warning
          onUpdate={this.updateBranch}
          onError={this.handleError}
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
        />
        <Show when={this.props.HasFederalService.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            onUpdate={this.updateList}
            onError={this.handleError}
            summary={this.summary}
            description={i18n.t('history.pvq.federal.collection.summary.title')}
            appendTitle={i18n.t('history.pvq.federal.collection.appendTitle')}
            appendLabel={i18n.t('history.pvq.federal.collection.append')}
            required={this.props.required}
            errors={accordionErrors}
            scrollIntoView={this.props.scrollIntoView}
            useAddWithData={true}
          >
            <FederalItem
              name="Item"
              bind
              addressBooks={this.props.addressBooks}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              onError={this.props.onError}
              formType={this.props.formType}
            />
          </Accordion>
        </Show>
      </div>
    ) : (
      <div
        className="section-content federal"
        data-section={HISTORY.key}
        data-subsection={HISTORY_FEDERAL.key}
      >
        <Branch
          attribute="HasFederalService"
          name="has_federalservice"
          label={i18n.t('history.federal.heading.branch')}
          labelSize="h4"
          help="history.federal.help.branch"
          helpTitle={i18n.t('history.federal.help.branch.title', { years })}
          {...this.props.HasFederalService}
          warning
          onUpdate={this.updateBranch}
          onError={this.handleError}
          required={this.props.required}
          scrollIntoView={this.props.scrollIntoView}
        />
        <Comments
          title={i18n.t(`history.federal.comments`)}
          name="Comments"
          attribute="Comments"
          className="optional-comments"
          {...this.props.Comments}
          onUpdate={this.updateComments}
          onError={this.props.onError}
          required={false}
        />
        <Show when={this.props.HasFederalService.value === 'Yes'}>
          <Accordion
            {...this.props.List}
            defaultState={this.props.defaultState}
            onUpdate={this.updateList}
            onError={this.handleError}
            summary={this.summary}
            description={i18n.t('history.federal.collection.summary.title')}
            appendTitle={i18n.t('history.federal.collection.appendTitle')}
            appendLabel={i18n.t('history.federal.collection.append')}
            required={this.props.required}
            errors={accordionErrors}
            scrollIntoView={this.props.scrollIntoView}
          >
            <FederalItem
              name="Item"
              bind
              addressBooks={this.props.addressBooks}
              required={this.props.required}
              scrollIntoView={this.props.scrollIntoView}
              onError={this.props.onError}
              formType={this.props.formType}
            />
          </Accordion>
          <Comments
            title={i18n.t(`history.federal.summarycomments`)}
            name="SummaryComments"
            attribute="SummaryComments"
            className="optional-comments"
            {...this.props.SummaryComments}
            onUpdate={this.updateSummaryComments}
            onError={this.props.onError}
            required={false}
          />
        </Show>
      </div>
    );
  }
}

Federal.propTypes = {
  required: PropTypes.bool,
};

Federal.defaultProps = {
  HasFederalService: {},
  List: EmptyListInstance,
  Comments: {},
  SummaryComments: {},
  onUpdate: () => { },
  onError: (value, arr) => arr,
  section: 'history',
  subsection: 'federal',
  addressBooks: {},
  dispatch: () => { },
  defaultState: true,
  errors: [],
};

export default connectSubsection(Federal, sectionConfig);
